module.exports = __webpack_public_path__ + "static/media/sad.5076c265.svg";